import { DieLigenTable } from "./DieLigenTable";

export const DieLigen = () => {
	return (
		<div className="api-container">
			<div className="listHeadline">Tasks</div>
			<DieLigenTable />
		</div>
	);
}